module.exports = __webpack_public_path__ + "static/media/pf_item_45.81815dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_45.jpg
// module id = 147
// module chunks = 0